<template>
    <b-form-group
        class="new"
        :state="state"
        :invalid-feedback="$t('form.validations.required')"
    >
        <template slot="label">
            <div class="label">{{ $t('nBox.calibratedQuadrant') }}</div>
        </template>
        <b-form-select
            :state="state"
            :options="options"
            :disabled="disabled"
            v-model="selectedQuadrant"
        />
    </b-form-group>
</template>
<script>
import { orderBy } from 'lodash'
import { getQuadrantTitle, getCentralValue } from '@/views/n-box/utils'
export default {
    props: {
        selected: Object,
        disabled: Boolean,
        xValue: {
            type: [String, Number],
            default: null,
        },
        yValue: {
            type: [String, Number],
            default: null,
        },
        quadrants: {
            type: Array,
            required: true,
        },
        state: {
            type: Boolean,
            default: null,
        },
    },
    computed: {
        options() {
            const options = this.quadrants.map(q => {
                return {
                    id: q.id,
                    text: getQuadrantTitle(q),
                    value: {
                        x: getCentralValue(q.x_min, q.x_max),
                        y: getCentralValue(q.y_min, q.y_max),
                    },
                }
            })
            return orderBy(options, 'text', 'asc')
        },
        selectedQuadrant: {
            get() {
                return this.selected
            },
            set(value) {
                this.emitUpdateEvent('selected', value)
            },
        },
    },
    watch: {
        selectedQuadrant(quadrant) {
            if (!quadrant) {
                return
            }
            this.emitChangeEvent(quadrant)
            this.emitUpdateEvent('xValue', quadrant.x)
            this.emitUpdateEvent('yValue', quadrant.y)
        },
    },
    methods: {
        emitUpdateEvent(prop, value) {
            this.$emit(`update:${prop}`, value)
        },
        emitChangeEvent(quadrant) {
            this.$emit('change', quadrant)
        },
    },
}
</script>
<style scoped>
.new {
    text-align: center;
    text-align-last: center;
    -moz-text-align-last: center;
}
</style>
